import { Button, Modal } from "antd";

import styles from "@/components/TransactionDetailsModal/TransactionDetailsModal.module.css";
import { TransactionInterface } from "@/types/pledgeService";
import { formatAmount } from "@/utils/formatAmount";
import { transactionDisplayAmount } from "@/utils/transactionDisplay";

const displayAmount = (value: number | null | undefined): string =>
  value ? formatAmount(Number(value)) : "-";

interface TransactionDetailsModalProps {
  open: boolean;
  onClose: () => void;
  transaction: TransactionInterface | null;
  currencySuffix: string;
}

const TransactionDetailsModal: React.FC<TransactionDetailsModalProps> = ({
  open,
  onClose,
  transaction,
  currencySuffix,
}) => {
  const isRenewal = transaction?.payment_type?.toLowerCase() === "renewal";
  const isGrouped = !!transaction?.renewal_stage;
  const isOldTicket = transaction?.renewal_stage === "old_ticket";
  const isPledgeCreation = transaction?.payment_type?.toLowerCase() === "pledge creation";
  const isDownloanRenewal =
    isRenewal &&
    (isGrouped || transaction?.pledge?.is_downloan === true) &&
    Number(transaction?.downloan_amount) > 0;
  const isUploanReceipt =
    isRenewal &&
    (isGrouped || transaction?.pledge?.is_uploan === true) &&
    Number(transaction?.uploan_amount) > 0;
  const pledgeAmount =
    transaction?.pledge?.offered_pledge_amount ?? transaction?.pledge?.requested_pledge_amount;
  const adminFee = isGrouped
    ? transaction?.admin_fee
    : (transaction?.pledge?.admin_fee ?? transaction?.admin_fee);
  const interestAmount = transaction?.interest_amount;
  const totalAmount =
    isGrouped && transaction
      ? transactionDisplayAmount(transaction)
      : isUploanReceipt
        ? Number(transaction?.uploan_amount)
        : isRenewal
          ? Number(interestAmount ?? 0) +
            Number(adminFee ?? 0) +
            (isDownloanRenewal ? Number(transaction?.downloan_amount) : 0)
          : (transaction?.total_amount ?? transaction?.paid_amount);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      className={styles.modal}
    >
      <div className={styles.title}>Transaction Details</div>

      {!isRenewal && (
        <div className={styles.row}>
          <span>Pledge Amount</span>
          <span>
            {displayAmount(pledgeAmount)} {currencySuffix}
          </span>
        </div>
      )}

      {!isPledgeCreation && !isUploanReceipt && (!isGrouped || isOldTicket) && (
        <div className={styles.row}>
          <span>Interest Amount</span>
          <span>
            {isGrouped ? formatAmount(Number(interestAmount ?? 0)) : displayAmount(interestAmount)}{" "}
            {currencySuffix}
          </span>
        </div>
      )}

      {isDownloanRenewal && (
        <div className={styles.row}>
          <span>Downloan Amount</span>
          <span>
            {displayAmount(transaction?.downloan_amount)} {currencySuffix}
          </span>
        </div>
      )}

      {isUploanReceipt && (
        <div className={styles.row}>
          <span>Uploan Amount</span>
          <span>
            {displayAmount(transaction?.uploan_amount)} {currencySuffix}
          </span>
        </div>
      )}

      {(isGrouped ? !isOldTicket : !isUploanReceipt) && (
        <div className={styles.row}>
          <span>Admin Fee</span>
          <span>
            {isGrouped ? formatAmount(Number(adminFee ?? 0)) : displayAmount(adminFee)}{" "}
            {currencySuffix}
          </span>
        </div>
      )}

      <div className={styles.divider} />

      <div className={styles.totalRow}>
        <span>Total Transaction Amount</span>
        <span>
          {isGrouped ? formatAmount(Number(totalAmount ?? 0)) : displayAmount(totalAmount)}{" "}
          {currencySuffix}
        </span>
      </div>

      <Button className={styles.closeButton} onClick={onClose}>
        Close
      </Button>
    </Modal>
  );
};

export default TransactionDetailsModal;
